var map = {
	"./Facebook.svg": 181,
	"./FacebookH.svg": 182,
	"./Instagram.svg": 183,
	"./InstagramH.svg": 184,
	"./Linkedin.svg": 185,
	"./LinkedinH.svg": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;